export default __webpack_public_path__ + "static/media/pakk5.db776cd7.jpg";